import logger from '@/lib/logger'
import { flags } from '@/store/flags'

// Return a boolean value if true/false is detected, otherwise
// returns the value as-is.
const parseValue = flag => {
  if (typeof flag === 'string') {
    if (flag === 'true') return true
    else if (flag === 'false') return false
    else return flag
  }

  return flag
}

export default function({ query, store }) {
  logger.debug('flags: extracting feature flags')

  const detected_flags = Object.keys(query).filter(
    key => flags.indexOf(key) >= 0
  )

  logger.debug('flags: detected flags', detected_flags)

  detected_flags.forEach(flag => {
    const params = { flag, value: parseValue(query[flag]) }
    logger.debug(`flags: detected ${params.flag}, setting ${params.value}`)
    store.commit('flags/update', params)
  })
}
